module.exports = __webpack_public_path__ + "static/img/logo.a37d7741.png";